import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 19, height: 19, rx: 4.5, fill: "#F3F3F3", stroke: "#E3E3E3" }));
const ForwardRef = forwardRef(SvgCheckbox);
export default ForwardRef;
